import React, { useRef, useEffect, useState } from 'react';
import './ConversationLog.css';

const SPEAKER_COLORS = ['blue', 'green', 'orange', 'purple', 'teal', 'red'];

function speakerColor(key) {
  if (key === 'arzt') return 'blue';
  const num = parseInt(key.replace('person_', ''), 10);
  return SPEAKER_COLORS[(num % (SPEAKER_COLORS.length - 1)) + 1] || 'gray';
}

function ConversationLog({ entries, doctorName }) {
  const [isOpen, setIsOpen] = useState(false);
  const bodyRef = useRef(null);

  useEffect(() => {
    if (isOpen && bodyRef.current) {
      bodyRef.current.scrollTop = bodyRef.current.scrollHeight;
    }
  }, [entries, isOpen]);

  function displayName(key) {
    if (key === 'arzt') return doctorName || 'Arzt';
    const num = parseInt(key.replace('person_', ''), 10);
    return `Person ${num}`;
  }

  return (
    <div className="card conv-log-card">
      <button className="conv-log-header" onClick={() => setIsOpen(o => !o)}>
        <div className="conv-log-header-left">
          <span className="conv-log-title">Gesprächsprotokoll</span>
          {entries.length > 0 && (
            <span className="conv-log-badge">{entries.length}</span>
          )}
        </div>
        <span className={`conv-log-chevron${isOpen ? ' open' : ''}`}>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M4 6l4 4 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </span>
      </button>

      {isOpen && (
        <div className="conv-log-body" ref={bodyRef}>
          {entries.length === 0 ? (
            <p className="conv-log-empty">Noch keine Einträge. Starten Sie die Aufnahme.</p>
          ) : (
            <div className="conv-entries">
              {entries.map(entry => {
                const isDoctor = entry.speaker === 'arzt';
                const color = speakerColor(entry.speaker);
                const name = displayName(entry.speaker);
                const time = new Date(entry.timestamp).toLocaleTimeString('de-DE', {
                  hour: '2-digit', minute: '2-digit', second: '2-digit',
                });
                return (
                  <div key={entry.id} className={`conv-entry-wrap conv-entry--${isDoctor ? 'left' : 'right'}`}>
                    <div className="conv-entry-meta">
                      <span className={`conv-speaker-tag conv-color-${color}`}>{name}</span>
                      <span className="conv-entry-time">{time}</span>
                    </div>
                    <div className={`conv-bubble conv-color-${color}-bg conv-bubble--${isDoctor ? 'left' : 'right'}`}>
                      <p className="conv-entry-text">{entry.text}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default ConversationLog;
